module.exports = __webpack_public_path__ + "img/login-distritofutbol.897137d3.svg";